/**
 * @flow
 * @relayHash e611e881c22acb13e7ac9fd32e497ab1
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Approvable = "NO" | "OPTIONAL" | "REQUIRED" | "%future added value";
export type DocumentStatus = "ACTIVE" | "DELETED" | "OLD" | "OLD_SAVE" | "PENDING" | "RETIRED" | "SAVED" | "SCHEDULED" | "%future added value";
export type RetirePolicyQueryVariables = {|
  documentPk: number
|};
export type RetirePolicyQueryResponse = {|
  +documentRetire: ?{|
    +document: ?{|
      +id: string,
      +pk: ?number,
      +name: string,
      +html: ?string,
      +author: {|
        +pk: ?number,
        +userDisplay: ?string,
        +firstName: string,
        +lastName: string,
        +profile: ?{|
          +title: ?string
        |},
      |},
      +category: {|
        +pk: ?number,
        +name: string,
      |},
      +bloc: {|
        +id: string,
        +name: string,
        +tenants: ?$ReadOnlyArray<?{|
          +pk: ?number,
          +name: string,
        |}>,
      |},
      +parent: ?{|
        +id: string
      |},
      +isAForm: boolean,
      +status: ?DocumentStatus,
      +restricted: boolean,
      +effectiveDate: ?string,
      +approvalDate: ?string,
      +expirationDate: ?string,
      +revisionDate: ?string,
      +statusChangedDate: ?string,
      +originationDate: ?string,
      +legacyEffectiveDate: ?string,
      +created: ?string,
      +modified: ?any,
      +approvable: Approvable,
      +headerImageUrl: ?string,
      +rssFeedUrl: ?string,
      +attachments: ?$ReadOnlyArray<?{|
        +title: ?string,
        +fileUrl: ?string,
      |}>,
      +tags: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +approvalSignatures: ?$ReadOnlyArray<?{|
        +approver: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +proxySigner: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +approvalStep: ?{|
          +name: ?string
        |},
        +approvedDate: ?string,
      |}>,
      +pastApprovalSignatures: ?$ReadOnlyArray<?{|
        +approver: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +proxySigner: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +approvalStep: ?{|
          +name: ?string
        |},
        +approvedDate: ?string,
      |}>,
      +regulations: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +draftVersionLink: ?string,
      +pendingVersionLink: ?string,
      +scheduledVersionLink: ?string,
    |},
    +policyActions: ?any,
    +error: ?{|
      +statusCode: ?number,
      +message: ?string,
    |},
  |}
|};
export type RetirePolicyQuery = {|
  variables: RetirePolicyQueryVariables,
  response: RetirePolicyQueryResponse,
|};
*/

/*
query RetirePolicyQuery(
  $documentPk: Int!
) {
  documentRetire(pk: $documentPk) {
    document {
      id
      pk
      name
      html
      author {
        pk
        userDisplay
        firstName
        lastName
        profile {
          title
          id
        }
        id
      }
      category {
        pk
        name
        id
      }
      bloc {
        id
        name
        tenants {
          pk
          name
          id
        }
      }
      parent {
        id
      }
      isAForm
      status
      restricted
      effectiveDate(formatted: true)
      approvalDate(formatted: true)
      expirationDate(formatted: true)
      revisionDate(formatted: true)
      statusChangedDate
      originationDate(formatted: true)
      legacyEffectiveDate(formatted: true)
      created
      modified
      approvable
      headerImageUrl
      rssFeedUrl
      attachments {
        title
        fileUrl
        id
      }
      tags {
        pk
        name
        id
      }
      approvalSignatures {
        approver {
          firstName
          lastName
          title
        }
        proxySigner {
          firstName
          lastName
          title
        }
        approvalStep {
          name
          id
        }
        approvedDate(formatted: true)
      }
      pastApprovalSignatures {
        approver {
          firstName
          lastName
          title
        }
        proxySigner {
          firstName
          lastName
          title
        }
        approvalStep {
          name
          id
        }
        approvedDate(formatted: true)
      }
      regulations {
        pk
        name
        id
      }
      draftVersionLink
      pendingVersionLink
      scheduledVersionLink
    }
    policyActions
    error {
      statusCode
      message
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: "LocalArgument",
        name: "documentPk",
        type: "Int!",
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: "Variable",
        name: "pk",
        variableName: "documentPk",
        type: "Int!"
      }
    ],
    v2 = {
      kind: "ScalarField",
      alias: null,
      name: "id",
      args: null,
      storageKey: null
    },
    v3 = {
      kind: "ScalarField",
      alias: null,
      name: "pk",
      args: null,
      storageKey: null
    },
    v4 = {
      kind: "ScalarField",
      alias: null,
      name: "name",
      args: null,
      storageKey: null
    },
    v5 = {
      kind: "ScalarField",
      alias: null,
      name: "html",
      args: null,
      storageKey: null
    },
    v6 = {
      kind: "ScalarField",
      alias: null,
      name: "userDisplay",
      args: null,
      storageKey: null
    },
    v7 = {
      kind: "ScalarField",
      alias: null,
      name: "firstName",
      args: null,
      storageKey: null
    },
    v8 = {
      kind: "ScalarField",
      alias: null,
      name: "lastName",
      args: null,
      storageKey: null
    },
    v9 = {
      kind: "ScalarField",
      alias: null,
      name: "title",
      args: null,
      storageKey: null
    },
    v10 = [v3, v4],
    v11 = {
      kind: "LinkedField",
      alias: null,
      name: "parent",
      storageKey: null,
      args: null,
      concreteType: "RLDatixDocumentType",
      plural: false,
      selections: [v2]
    },
    v12 = {
      kind: "ScalarField",
      alias: null,
      name: "isAForm",
      args: null,
      storageKey: null
    },
    v13 = {
      kind: "ScalarField",
      alias: null,
      name: "status",
      args: null,
      storageKey: null
    },
    v14 = {
      kind: "ScalarField",
      alias: null,
      name: "restricted",
      args: null,
      storageKey: null
    },
    v15 = [
      {
        kind: "Literal",
        name: "formatted",
        value: true,
        type: "Boolean"
      }
    ],
    v16 = {
      kind: "ScalarField",
      alias: null,
      name: "effectiveDate",
      args: v15,
      storageKey: "effectiveDate(formatted:true)"
    },
    v17 = {
      kind: "ScalarField",
      alias: null,
      name: "approvalDate",
      args: v15,
      storageKey: "approvalDate(formatted:true)"
    },
    v18 = {
      kind: "ScalarField",
      alias: null,
      name: "expirationDate",
      args: v15,
      storageKey: "expirationDate(formatted:true)"
    },
    v19 = {
      kind: "ScalarField",
      alias: null,
      name: "revisionDate",
      args: v15,
      storageKey: "revisionDate(formatted:true)"
    },
    v20 = {
      kind: "ScalarField",
      alias: null,
      name: "statusChangedDate",
      args: null,
      storageKey: null
    },
    v21 = {
      kind: "ScalarField",
      alias: null,
      name: "originationDate",
      args: v15,
      storageKey: "originationDate(formatted:true)"
    },
    v22 = {
      kind: "ScalarField",
      alias: null,
      name: "legacyEffectiveDate",
      args: v15,
      storageKey: "legacyEffectiveDate(formatted:true)"
    },
    v23 = {
      kind: "ScalarField",
      alias: null,
      name: "created",
      args: null,
      storageKey: null
    },
    v24 = {
      kind: "ScalarField",
      alias: null,
      name: "modified",
      args: null,
      storageKey: null
    },
    v25 = {
      kind: "ScalarField",
      alias: null,
      name: "approvable",
      args: null,
      storageKey: null
    },
    v26 = {
      kind: "ScalarField",
      alias: null,
      name: "headerImageUrl",
      args: null,
      storageKey: null
    },
    v27 = {
      kind: "ScalarField",
      alias: null,
      name: "rssFeedUrl",
      args: null,
      storageKey: null
    },
    v28 = {
      kind: "ScalarField",
      alias: null,
      name: "fileUrl",
      args: null,
      storageKey: null
    },
    v29 = [v7, v8, v9],
    v30 = {
      kind: "LinkedField",
      alias: null,
      name: "approver",
      storageKey: null,
      args: null,
      concreteType: "ApprovalSignatureApproverType",
      plural: false,
      selections: v29
    },
    v31 = {
      kind: "LinkedField",
      alias: null,
      name: "proxySigner",
      storageKey: null,
      args: null,
      concreteType: "ApprovalSignatureApproverType",
      plural: false,
      selections: v29
    },
    v32 = {
      kind: "ScalarField",
      alias: null,
      name: "approvedDate",
      args: v15,
      storageKey: "approvedDate(formatted:true)"
    },
    v33 = [
      v30,
      v31,
      {
        kind: "LinkedField",
        alias: null,
        name: "approvalStep",
        storageKey: null,
        args: null,
        concreteType: "ApprovalStepType",
        plural: false,
        selections: [v4]
      },
      v32
    ],
    v34 = {
      kind: "ScalarField",
      alias: null,
      name: "draftVersionLink",
      args: null,
      storageKey: null
    },
    v35 = {
      kind: "ScalarField",
      alias: null,
      name: "pendingVersionLink",
      args: null,
      storageKey: null
    },
    v36 = {
      kind: "ScalarField",
      alias: null,
      name: "scheduledVersionLink",
      args: null,
      storageKey: null
    },
    v37 = {
      kind: "ScalarField",
      alias: null,
      name: "policyActions",
      args: null,
      storageKey: null
    },
    v38 = {
      kind: "LinkedField",
      alias: null,
      name: "error",
      storageKey: null,
      args: null,
      concreteType: "ErrorType",
      plural: false,
      selections: [
        {
          kind: "ScalarField",
          alias: null,
          name: "statusCode",
          args: null,
          storageKey: null
        },
        {
          kind: "ScalarField",
          alias: null,
          name: "message",
          args: null,
          storageKey: null
        }
      ]
    },
    v39 = [v3, v4, v2],
    v40 = [
      v30,
      v31,
      {
        kind: "LinkedField",
        alias: null,
        name: "approvalStep",
        storageKey: null,
        args: null,
        concreteType: "ApprovalStepType",
        plural: false,
        selections: [v4, v2]
      },
      v32
    ];
  return {
    kind: "Request",
    operationKind: "query",
    name: "RetirePolicyQuery",
    id: "ae495c890dbdaf881b927bb8ca6c3fd6",
    text: null,
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "RetirePolicyQuery",
      type: "Query",
      metadata: null,
      argumentDefinitions: v0,
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "documentRetire",
          storageKey: null,
          args: v1,
          concreteType: "DocumentRetireType",
          plural: false,
          selections: [
            {
              kind: "LinkedField",
              alias: null,
              name: "document",
              storageKey: null,
              args: null,
              concreteType: "DocumentType",
              plural: false,
              selections: [
                v2,
                v3,
                v4,
                v5,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "author",
                  storageKey: null,
                  args: null,
                  concreteType: "ApprovalStepUserType",
                  plural: false,
                  selections: [
                    v3,
                    v6,
                    v7,
                    v8,
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "profile",
                      storageKey: null,
                      args: null,
                      concreteType: "ProfileType",
                      plural: false,
                      selections: [v9]
                    }
                  ]
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "category",
                  storageKey: null,
                  args: null,
                  concreteType: "CategoryType",
                  plural: false,
                  selections: v10
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "bloc",
                  storageKey: null,
                  args: null,
                  concreteType: "BlocType",
                  plural: false,
                  selections: [
                    v2,
                    v4,
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "tenants",
                      storageKey: null,
                      args: null,
                      concreteType: "TenantType",
                      plural: true,
                      selections: v10
                    }
                  ]
                },
                v11,
                v12,
                v13,
                v14,
                v16,
                v17,
                v18,
                v19,
                v20,
                v21,
                v22,
                v23,
                v24,
                v25,
                v26,
                v27,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "attachments",
                  storageKey: null,
                  args: null,
                  concreteType: "DocumentAttachmentType",
                  plural: true,
                  selections: [v9, v28]
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "tags",
                  storageKey: null,
                  args: null,
                  concreteType: "TagType",
                  plural: true,
                  selections: v10
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "approvalSignatures",
                  storageKey: null,
                  args: null,
                  concreteType: "ApprovalSignatureType",
                  plural: true,
                  selections: v33
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "pastApprovalSignatures",
                  storageKey: null,
                  args: null,
                  concreteType: "ApprovalSignatureType",
                  plural: true,
                  selections: v33
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "regulations",
                  storageKey: null,
                  args: null,
                  concreteType: "RegulationType",
                  plural: true,
                  selections: v10
                },
                v34,
                v35,
                v36
              ]
            },
            v37,
            v38
          ]
        }
      ]
    },
    operation: {
      kind: "Operation",
      name: "RetirePolicyQuery",
      argumentDefinitions: v0,
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "documentRetire",
          storageKey: null,
          args: v1,
          concreteType: "DocumentRetireType",
          plural: false,
          selections: [
            {
              kind: "LinkedField",
              alias: null,
              name: "document",
              storageKey: null,
              args: null,
              concreteType: "DocumentType",
              plural: false,
              selections: [
                v2,
                v3,
                v4,
                v5,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "author",
                  storageKey: null,
                  args: null,
                  concreteType: "ApprovalStepUserType",
                  plural: false,
                  selections: [
                    v3,
                    v6,
                    v7,
                    v8,
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "profile",
                      storageKey: null,
                      args: null,
                      concreteType: "ProfileType",
                      plural: false,
                      selections: [v9, v2]
                    },
                    v2
                  ]
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "category",
                  storageKey: null,
                  args: null,
                  concreteType: "CategoryType",
                  plural: false,
                  selections: v39
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "bloc",
                  storageKey: null,
                  args: null,
                  concreteType: "BlocType",
                  plural: false,
                  selections: [
                    v2,
                    v4,
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "tenants",
                      storageKey: null,
                      args: null,
                      concreteType: "TenantType",
                      plural: true,
                      selections: v39
                    }
                  ]
                },
                v11,
                v12,
                v13,
                v14,
                v16,
                v17,
                v18,
                v19,
                v20,
                v21,
                v22,
                v23,
                v24,
                v25,
                v26,
                v27,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "attachments",
                  storageKey: null,
                  args: null,
                  concreteType: "DocumentAttachmentType",
                  plural: true,
                  selections: [v9, v28, v2]
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "tags",
                  storageKey: null,
                  args: null,
                  concreteType: "TagType",
                  plural: true,
                  selections: v39
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "approvalSignatures",
                  storageKey: null,
                  args: null,
                  concreteType: "ApprovalSignatureType",
                  plural: true,
                  selections: v40
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "pastApprovalSignatures",
                  storageKey: null,
                  args: null,
                  concreteType: "ApprovalSignatureType",
                  plural: true,
                  selections: v40
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "regulations",
                  storageKey: null,
                  args: null,
                  concreteType: "RegulationType",
                  plural: true,
                  selections: v39
                },
                v34,
                v35,
                v36
              ]
            },
            v37,
            v38
          ]
        }
      ]
    }
  };
})();
node.text =
  "query RetirePolicyQuery(\n  $documentPk: Int!\n) {\n  documentRetire(pk: $documentPk) {\n    document {\n      id\n      pk\n      name\n      html\n      author {\n        pk\n        userDisplay\n        firstName\n        lastName\n        profile {\n          title\n          id\n        }\n        id\n      }\n      category {\n        pk\n        name\n        id\n      }\n      bloc {\n        id\n        name\n        tenants {\n          pk\n          name\n          id\n        }\n      }\n      parent {\n        id\n      }\n      isAForm\n      status\n      restricted\n      effectiveDate(formatted: true)\n      approvalDate(formatted: true)\n      expirationDate(formatted: true)\n      revisionDate(formatted: true)\n      statusChangedDate\n      originationDate(formatted: true)\n      legacyEffectiveDate(formatted: true)\n      created\n      modified\n      approvable\n      headerImageUrl\n      rssFeedUrl\n      attachments {\n        title\n        fileUrl\n        id\n      }\n      tags {\n        pk\n        name\n        id\n      }\n      approvalSignatures {\n        approver {\n          firstName\n          lastName\n          title\n        }\n        proxySigner {\n          firstName\n          lastName\n          title\n        }\n        approvalStep {\n          name\n          id\n        }\n        approvedDate(formatted: true)\n      }\n      pastApprovalSignatures {\n        approver {\n          firstName\n          lastName\n          title\n        }\n        proxySigner {\n          firstName\n          lastName\n          title\n        }\n        approvalStep {\n          name\n          id\n        }\n        approvedDate(formatted: true)\n      }\n      regulations {\n        pk\n        name\n        id\n      }\n      draftVersionLink\n      pendingVersionLink\n      scheduledVersionLink\n    }\n    policyActions\n    error {\n      statusCode\n      message\n    }\n  }\n}\n";
(node /*: any*/).hash = "ff3862fa690b81d9455a7743c1f82a17";
module.exports = node;
